<mat-dialog-content>
    <!-- <div class="verification-modal">
        <mat-icon class="verified-icon text-success"aria-hidden="false" aria-label="Example home icon" fontIcon="check_circle_outline"></mat-icon>
       <mat-icon class="verified-icon text-danger"aria-hidden="false" aria-label="Example home icon" fontIcon="info_outline"></mat-icon> 
        <h3>Email Verified!</h3>
        <h4>Your email verification is complete now lets complete Sign up</h4>
        <button mat-flat-button color="primary" class="my-3 px-5">Ok</button>
    </div> -->

    <div class="modal-header border-bottom d-flex align-items-center justify-content-between pb-3">
        <h5 class="modal-title m-0">Delete</h5>
         <button type="button" #closebutton class="close btn-close"
          [mat-dialog-close]="false" data-dismiss="modal"> <i
            class="fa-solid fa-xmark"></i></button> 
      </div>
      <div class="modal-body py-3">
        <p>Are you sure you want to delete this {{Name}} ?</p>
      </div>
      <div class="modal-footer">
        <div class="action-btn d-flex">
          <button class="btn btn-primary me-3" [mat-dialog-close]="true" >Yes</button>
          <button class="btn btn-secondary me-3"[mat-dialog-close]="false" >No</button>
        </div>
      </div>
  </mat-dialog-content>
  


  